<template>
  <main class="flex justify-center font-zona">
    <div
      class="flex max-sm:flex-col gap-5 lg:gap-10 w-full min-[1200px]:w-4/5 max-[1199px]:p-5 py-5"
    >
      <div class="w-full">
        <div v-if="reports.length > 0 && !isLoading" class="w-full mb-10">
          <div class="grid grid-cols-1 min-[900px]:grid-cols-2 gap-10 w-full">
            <div
              v-for="file in reports"
              :key="file.id"
              v-motion-slide-visible-once-bottom
              :duration="1000"
              class="bg-gray-100 p-5 space-y-5 shadow"
            >
              <h6 class="font-bold text-sm text-green">
                {{ lang === "mn" ? file.created_at : file.created_at_en }}
              </h6>
              <img
                :src="file.image"
                :alt="file.id"
                class="w-full h-[12rem] object-cover"
              />
              <h1
                class="font-bold text-base sm:text-lg md:text-xl line-clamp-3 sm:line-clamp-2"
              >
                {{ lang === "mn" ? file.title : file.title_en }}
              </h1>
              <button
                @click="downloadFile(file.pdf, file.title)"
                class="bg-green py-2 w-[10rem] rounded-full text-white text-sm uppercase hover:scale-105"
              >
                <font-awesome-icon icon="fa-solid fa-download" class="mr-1" />
                {{ lang === "mn" ? "Татах" : "Download" }}
              </button>
            </div>
          </div>

          <div class="flex justify-center w-full my-10">
            <PaginationCart
              :totalPages="totalPages"
              :modelValue="currentPage"
              :style="{
                color: 'green',
                height: 10,
                width: 10,
                fontSize: 'sm',
              }"
              @page-changed="onPageChanged"
            />
          </div>
        </div>

        <div
          v-else-if="reports.length === 0 && !isLoading"
          class="flex justify-center items-center w-full h-[10rem] md:text-2xl bg-gray-100"
        >
          {{ lang === "mn" ? "Тайлан хоосон байна" : "No Report Found" }}
        </div>

        <div v-else class="flex justify-center items-center w-full h-[50vh]">
          <SpinLoading />
        </div>
      </div>

      <NewsPageSide />
    </div>
  </main>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import clientInstance from "@/lib/clientInstance";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import NewsPageSide from "@/containers/MiningMongolia/NewsPageSide.vue";
import PaginationCart from "@/components/ui/PaginationCart.vue";
import SpinLoading from "@/components/ui/SpinLoading.vue";

export default {
  name: "MMReportList",
  components: { NewsPageSide, PaginationCart, SpinLoading },
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const router = useRouter();
    const route = useRoute();
    const reports = ref([]);
    const isLoading = ref(false);
    const currentPage = ref(parseInt(route.params.page) || 1);
    const totalPages = ref(1);

    const fetchData = async (page) => {
      try {
        isLoading.value = true;
        const res = await clientInstance.get(
          `/get/report?lang=${lang.value}&page=${page}&limit=${6}`
        );
        reports.value = res.data.reports;
        totalPages.value = res.data.totalPages;
      } catch (err) {
        console.error(err);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      fetchData(route.params.page || 1);
    });

    watch([() => lang], () => {
      currentPage.value = 1;
      fetchData(currentPage.value);
    });

    const onPageChanged = (page) => {
      currentPage.value = page;
      fetchData(page);
      router.push(`/mm/report=${currentPage.value}`);
    };

    const downloadFile = (pdfUrl, title) => {
      fetch(pdfUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", title + ".pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error downloading file:", error));
    };

    return {
      lang,
      isLoading,
      currentPage,
      totalPages,
      onPageChanged,
      reports,
      downloadFile,
    };
  },
};
</script>
